<template>
  <portal to="modals">
    <app-modal
      @close="$emit('close')"
    >
      <div class="max-w-md mx-auto content text-white">
        <div>
          <icon
            icon="important"
            class="icons-white w-16 h-16 mb-2"
          />
          <h2 class="mb-1">
            Confirmation
          </h2>
          <p class="font-bold">
            By signing your name below, you're are accepting that you agree to this contract and that you are a Director or duly authorised Officer for and on behalf of {{ company }}.
          </p>
          <div class="flex mt-12 mb-4 items-end">
            <input
              ref="signature"
              v-model.trim="confirmation.signature"
              class="block w-2/3 text-4xl py-2 border-b-2 border-white focus:border-primary-400 focus:outline-none bg-transparent text-white font-script"
              type="text"
              :disabled="loading"
              :placeholder="userName"
            >
            <icon
              :icon="userName === confirmation.signature ? 'check' : 'edit'"
              class="w-8 h-8 ml-6"
              :class="{
                'icons-white' : userName !== confirmation.signature,
                'icons-positive' : userName === confirmation.signature
              }"
            />
          </div>
          <p>
            <strong>{{ userName }}</strong>
            <template v-if="userPosition">
              <br> <em>{{ userPosition }} - {{ company }}</em>
            </template>
          </p>
          <p class="mt-12">
            <app-button
              :disabled="userName !== confirmation.signature || loading"
              colour="confirm"
              @click="$emit('contract:submit')"
            >
              I accept
            </app-button>
            <app-button
              colour="close"
              @click="$emit('close')"
            >
              I don't accept
            </app-button>
          </p>
        </div>
      </div>
    </app-modal>
  </portal>
</template>
<script>
export default {
  name: 'ContractConfirmationModal',
  props: {
    project: {
      type: Object,
      required: true
    },
    confirmation: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    company() {
      return this.user.company.name
    },
    userName() {
      return this.user.name
    },
    userPosition() {
      return this.user.job_title
    }
  },
  mounted() {
    this.$nextTick(() => this.$refs.signature.focus() )
  }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css?family=Marck+Script&display=swap');
.font-script {
  font-family: 'Marck Script', cursive;
}
</style>
